<div class="backdrop" (click)="onClose()"></div>
<div class="alert-box">
    <p>{{message | translate}}</p>
    <div class="alert-box-actions">
        <button class="button--primary button-xs" (click)="onClose()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
    </div>
</div>
